import { render } from "./MultiImageDisplay.vue?vue&type=template&id=6c537c1c&scoped=true"
import script from "./MultiImageDisplay.vue?vue&type=script&lang=js"
export * from "./MultiImageDisplay.vue?vue&type=script&lang=js"

import "./MultiImageDisplay.vue?vue&type=style&index=0&id=6c537c1c&scoped=true&lang=scss"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c537c1c"]])

export default __exports__